// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_av-b";
export var colorBlue = "_av-8";
export var colorDot = "_av-0";
export var colorDotLarge = "_av-2";
export var colorDotSmall = "_av-1";
export var colorGreen = "_av-7";
export var colorGrey = "_av-3";
export var colorOrange = "_av-5";
export var colorPink = "_av-a";
export var colorPurple = "_av-9";
export var colorRed = "_av-4";
export var colorYellow = "_av-6";